<template>
  <div class="myevents container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Events</h4>
              </div>
            </div>
          </div>
          <EventsList
            client_name="MID"
            :filter_buttons="filter_buttons"
            :events="events"
            :currency="'$'"
            images_folder="my-irish-date"
            sub_title="Upcoming Events"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import EventsList from "@/components/events/List.vue";

export default {
  name: "MyEvents",
  components: { EventsList },
  data() {
    return {
      filter_buttons: [
        { name: "Small Groups", value: "small_group" },
        { name: "Large Interactive Events", value: "large_interactive" },
        { name: "Large Host-centered Events", value: "large_host_centered" },
      ],
      events: [
        // {
        //   id: 1,
        //   event_name: "My Irish Date zoom event",
        //   event_type: "small_group",
        //   max_participants: 150,
        //   location: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: true,
        //   event_img:
        //     "data:image/jpeg;base64,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",
        //   has_sessions: true,
        // },
        // {
        //   id: 2,
        //   event_name: "MyIrishDate live Couple Cooking Class",
        //   event_type: "small_group",
        //   max_participants: 150,
        //   location: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: false,
        //   event_img: require("@/assets/images/my-irish-date/event2.png"),
        //   has_sessions: false,
        // },
        // {
        //   id: 3,
        //   event_name: "My Irish date event",
        //   event_type: "large_interactive",
        //   max_participants: 150,
        //   location: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: true,
        //   event_img: require("@/assets/images/my-irish-date/event3.png"),
        //   has_sessions: null,
        // },
        // {
        //   id: 4,
        //   event_name: "MYIRISHDATE ONLINE DATING COACHES",
        //   event_type: "large_interactive",
        //   max_participants: 150,
        //   location: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: false,
        //   event_img: require("@/assets/images/my-irish-date/event1.png"),
        //   has_sessions: null,
        // },
        // {
        //   id: 5,
        //   event_name: "MYIRISHDATE BLIND DATING EVENT",
        //   event_type: "large_host_centered",
        //   max_participants: 150,
        //   location: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: true,
        //   event_img: "",
        //   has_sessions: null,
        // },
      ],
    };
  },
  mounted() {
    this.getEventsList();
  },
  computed: {},
  created() {},
  methods: {
    getEventsList() {
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token)
      axios
        .get("event/events", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "MID",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.events = response.data;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/events/List.vue